import React from 'react';
import { IconProps } from './model/IconInterface';

const CameraIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24'
       fill='none' stroke={color}
       strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3 8.5a1 1 0 0 1 1-1h2.7l1.2-2a1 1 0 0 1 .86-.5h4.48a1 1 0 0 1 .86.5l1.2 2H20a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8.5Z' />
    <circle cx='12' cy='13' r='3.2' />
  </svg>
);

export default CameraIcon;
